import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Service } from "../services/service";
import { BASE_URL } from "../constants/constant";

const service = new Service();

// User Slice
export const initialState = {
  allExpenseTargets: {},
  allTranslationsOutput: [],
  allChannelTranslation: {},
  loading: false,
  isTranslationAdded: null,
};

export const getAllExpenseTargets = createAsyncThunk(
  "get-all-expense-targets",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetAllExpenseTargets?organizationId=${obj.organisationId}&year=${obj.year}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getTranslationsOutput = createAsyncThunk(
  "get-translations-output",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetTranslationsOutput?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getAnnualGivingOutput = createAsyncThunk(
  "get-annual-giving-output",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetAnnualGivingData?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data.data;
    return data;
  }
);

export const getChannelTranslation = createAsyncThunk(
  "get-channel-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetChannelTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getProgramTranslation = createAsyncThunk(
  "get-program-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetProgramTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getAppealCategoryTranslation = createAsyncThunk(
  "get-appeal-category-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetAppealCategoryTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getAnnualGivingTranslation = createAsyncThunk(
  "get-annual-giving-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetAnnualGivingTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getFundPurposeTranslation = createAsyncThunk(
  "get-fund-purpose-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetFundPurposeTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

export const getPhilanthropicFundTranslation = createAsyncThunk(
  "get-philanthropic-fund-translation",
  async (obj) => {
    const url = `${BASE_URL}/api/Translations/GetPhilanthropicFundTranslation?translationId=${obj?.translationId}&organizationId=${obj?.organisationId}&transType=${obj?.transType}`;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, {}, user_token);
    const data = response.data;
    return data;
  }
);

const translationSlice = createSlice({
  name: "translation",
  initialState,
  reducers: {
    setIsTranslationAdded(state, action) {
      state.isTranslationAdded = action.payload;
    },
    updateTranslation(state, action) {
      state.allChannelTranslation = action.payload;
    },
  },
  extraReducers: {
    [getAllExpenseTargets.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getAllExpenseTargets.fulfilled]: (state, { payload }) => {
      state.allExpenseTargets = payload;
      state.isTranslationAdded = payload?.isTranslationAdded;
      state.loading = false;
    },
    [getAllExpenseTargets.rejected]: (state, { payload }) => {
      state.allExpenseTargets = {};
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getTranslationsOutput.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getTranslationsOutput.fulfilled]: (state, { payload }) => {
      state.allTranslationsOutput = payload;
      state.loading = false;
    },
    [getTranslationsOutput.rejected]: (state, { payload }) => {
      state.allTranslationsOutput = [];
      state.loading = false;
    },
    [getAnnualGivingOutput.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getAnnualGivingOutput.fulfilled]: (state, { payload }) => {
      state.allTranslationsOutput = payload;
      state.loading = false;
    },
    [getAnnualGivingOutput.rejected]: (state, { payload }) => {
      state.allTranslationsOutput = [];
      state.loading = false;
    },
    [getChannelTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getChannelTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getChannelTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getProgramTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getProgramTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getProgramTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getAppealCategoryTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getAppealCategoryTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getAppealCategoryTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getAnnualGivingTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getAnnualGivingTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getAnnualGivingTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getFundPurposeTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getFundPurposeTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getFundPurposeTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
    [getPhilanthropicFundTranslation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getPhilanthropicFundTranslation.fulfilled]: (state, { payload }) => {
      state.allChannelTranslation = payload;
      state.isTranslationAdded = payload?.data?.isTranslationAdded;
      state.loading = false;
    },
    [getPhilanthropicFundTranslation.rejected]: (state, { payload }) => {
      state.allChannelTranslation = [];
      state.isTranslationAdded = null;
      state.loading = false;
    },
  },
});
export const { setIsTranslationAdded, updateTranslation } =
  translationSlice.actions;
export default translationSlice.reducer;
